export const iconFontAwesomeShoppingAmazonPay = (
	<i className="fa-solid fa-amazon-pay"></i>
);
